'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import UIRouterSideNav from 'ui-addon-react-router-dom/UIRouterSideNav';
import UIRouterSideNavItem from 'ui-addon-react-router-dom/UIRouterSideNavItem';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
export const MyLearningSideNav = () => /*#__PURE__*/_jsxs(UIRouterSideNav, {
  headingText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.myLearning.sidebarTitle"
  }),
  children: [/*#__PURE__*/_jsx(UIRouterSideNavItem, {
    "data-test-id": "mylearning-in-progress",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.status.IN_PROGRESS"
    }),
    to: "/mylearning/in-progress"
  }), /*#__PURE__*/_jsx(UIRouterSideNavItem, {
    "data-test-id": "mylearning-completed",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.status.COMPLETED"
    }),
    to: "/mylearning/completed"
  })]
});